module.exports = __webpack_public_path__ + "static/runner-6ef6a9d05d20a8a4669982c373a46797.svg";